import React from 'react';
import styled from 'styled-components';
import { variables } from '@splunk/themes';
import type { InputContainerOptions } from '@splunk/dashboard-types';

import { sanitizeColor } from '../utils';

interface InputTitleContainerProps {
    containerOptions?: InputContainerOptions;
}

const InputTitleContainer = styled.div.attrs({
    'data-test': 'input-title',
})<InputTitleContainerProps>`
    display: flex;
    align-items: baseline;
    overflow: hidden;
    white-space: nowrap;
    font-size: 13px;
    cursor: default;
    color: ${variables.contentColorActive};
    color: ${(props) =>
        props.containerOptions?.title?.color
            ? sanitizeColor(props.containerOptions?.title?.color)
            : variables.contentColorActive};
    flex-grow: 0;
`;

const InputTitleText = styled.span`
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    min-width: 0;
`;

export interface InputTitleProps extends InputTitleContainerProps {
    title?: string;
    inputId?: string;
    titleId?: string;
    withInputLabel?: boolean;
}

export const InputTitle = ({
    title,
    containerOptions,
    inputId,
    titleId,
    withInputLabel,
}: InputTitleProps) => {
    return (
        <InputTitleContainer
            title={title}
            containerOptions={containerOptions}
            as={withInputLabel ? 'label' : 'div'}
            htmlFor={withInputLabel ? inputId : undefined}
        >
            <InputTitleText id={titleId}>{title}</InputTitleText>
        </InputTitleContainer>
    );
};
